import SavedReportsPage from './SavedReportsPage';

export default SavedReportsPage;
